export enum LayeredLayoutDirection {
  TopDown = 'top-down',
  BottomUp = 'bottom-up',
  LeftRight = 'left-right',
  RightLeft = 'right-left',
}
